module.exports = __webpack_public_path__ + "static/media/Hex-Icon.0ce3fd48.png";